module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_5012.366206a0.png";